export const getLessonById = (currentCourse, lessonId) => {
  const modules = currentCourse.modules;

  for (const module of modules) {
    const lesson = module.lessons.find((lesson) => lesson.id === lessonId);

    if (lesson) {
      return lesson;
    }
  }

  return null;
};

export const convertTheoryLessonToApi = (lesson, courseId, moduleId) => ({
  blocks: lesson.blocks,
  courseId,
  moduleId,
  free: lesson.free,
  order: lesson.order,
  soon: lesson.soon,
  status: lesson.status,
  title: lesson.title,
  type: lesson.type,
});

export const convertFigmaLessonToApi = (lesson, courseId, moduleId) => ({
  courseId,
  moduleId,
  free: lesson.free,
  order: lesson.order,
  soon: lesson.soon,
  status: lesson.status,
  title: lesson.title,
  type: lesson.type,
  description: lesson.description,
  designType: lesson.designType,
  fileId: lesson.fileId,
  filePageId: lesson.filePageId,
  goodToKnowBlocks: lesson.goodToKnowBlocks,
  canvasTheory: lesson.canvasTheory,
  initialState: lesson.initialState,
  kind: lesson.kind,
  percentToComplete: lesson.percentToComplete,
  resultPreview: lesson.resultPreview,
  resultRefPreview: lesson.resultRefPreview,
  tasks: lesson.tasks,
});
